import { ChangeDetectorRef, Component, EventEmitter, Inject, LOCALE_ID, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { DatagridComponent } from '@farris/ui-datagrid';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-variable-grid',
  templateUrl: './variable-grid.component.html',
  styleUrls: ['./variable-grid.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class VariableGridComponent implements OnInit {

  @ViewChild(DatagridComponent) grid: DatagridComponent;
  @ViewChild('buttonRef') buttonRef: TemplateRef<any>;
  @Output() cancel = new EventEmitter<any>();
  @Output() submit = new EventEmitter<any>();

  data = [];

  columns = [
    { field: 'key', width: 50, title: this.localePipe.transform('component.executeForms.key')},
    { field: 'name', width: 50, title: this.localePipe.transform('component.executeForms.name')}
  ];

  constructor(
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  clickOK() {
    const selectedRow = this.grid.selectedRow;
    console.log(selectedRow);
    if (!selectedRow) {
      this.submit.next(null);
    } else {
      this.submit.next(selectedRow.data);
    }
  }

  clickCancel() {
    this.cancel.next();
  }
}
